import { graphql, useStaticQuery } from "gatsby"

export const useFooterDetails = () => {
  const data = useStaticQuery(graphql`
    query FooterDetailsQuery {
      butterPage(slug: { eq: "footer-details" }) {
        tagline
        social_media_links {
          icon
          name
          url
          visible
        }
        links {
          column
          heading
          text
          url
        }
      }
    }
  `)

  return data.butterPage
}
